<template>
    <main>
        <header class="header">
            <DemoBar />
            <div class="container py-3">
                <div class="row">
                    <div class="col-7 mx-auto">
                        <a class="" href="/">
                            <img src="/img/logo-white.svg">
                        </a>
                    </div>
                </div>
            </div>
        </header>
        <article>
            <slot />
        </article>

        <footer class="footer-login mt-5">
            <div class="container">
                <div class="row">
                    <div class="col-10 col-md-7 mx-auto text-center">
                        <a :href="$page.props.config.dlr_website" class="font-poppins font-weight-medium color-dark-blue"><u>
                            {{ Lang.get('employerdashboard::shared.clean_layout.what_is_de_leerrekening') }}
                        </u></a>
                    </div>
                </div>
            </div>
        </footer>

    </main>
</template>

<script>
import DemoBar from '@/Shared/DemoBar';

export default {

    components: {
        DemoBar
    },

    props: {
        title: {
            type: String,
            default() {
                return 'DeLeerrekening';
            }
        },
    },

    watch: {
        title: {
            immediate: true,
            handler(title) {
                document.title = title
            },
        },
    },

    methods: {
        url() {
            return location.href;
        },
    },

    mounted () {
        document.body.classList.add('background-company')
    },

    destroyed () {
        document.body.classList.remove('background-company')
    }
}
</script>
